import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {ReportsService} from '../../reports.service';
import { FlexModule } from '@angular/flex-layout';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { ChartByGroupsComponent } from './chart-by-groups.component';
import { ChartGroupsByTimeComponent } from './chart-groups-by-time.component';
import { MatButton } from '@angular/material/button';

export interface MatAgentGroupsDashboardZoomDialogData {
  chartData: any[];
  showChartByTime: boolean;
  dialogTitle: string;
  timeSeriesType: 'line' | 'bar';
  chartType: 'pie' | 'bar';
  groupsSeriesType: string;
  filterType: any;
  startDate: string;
  endDate: string;
}

@Component({
    selector: 'app-mat-chart-user-dialog',
    template: `
      <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
          <mat-dialog-content class="mat-typography" fxFlex>
              <app-chart-by-groups *ngIf="!data.showChartByTime" [chartType]="data.chartType" [data]="data.chartData"
                                   [selectedFilterType]="data.filterType"></app-chart-by-groups>

              <app-chart-groups-by-time *ngIf="data.showChartByTime" [data]="data.chartData"
                                        [startDate]="data.startDate" [endDate]="data.endDate"
                                        [chartType]="data.timeSeriesType" [selectedFilterType]="data.filterType"></app-chart-groups-by-time>
          </mat-dialog-content>

          <mat-dialog-actions align="end">
              <button mat-button mat-dialog-close="">Close</button>
          </mat-dialog-actions>
      </div>
  `,
    standalone: true,
    imports: [
        FlexModule,
        CdkScrollable,
        MatDialogContent,
        NgIf,
        ChartByGroupsComponent,
        ChartGroupsByTimeComponent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class MatGroupsDashboardZoomDialogComponent implements OnInit, OnDestroy {

  constructor(public reportsService: ReportsService,
              public dialogRef: MatDialogRef<MatGroupsDashboardZoomDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: MatAgentGroupsDashboardZoomDialogData
  ) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}
